import React from 'react';
import { Box, TextField, FormControl } from '@mui/material';
import { toCapitalizeCase } from '../../../../../utils/methods';
import { borderInput } from '../../../../formAddress/formAddress.styles';
import { boxStyles, useStyles, inputRowStyles } from '../../modalVolunteerDetails.styles';
import { IPropsControl } from '../../types';

export const ContactControl = (props: IPropsControl): JSX.Element => {
  const classes = useStyles();
  const { volunteer } = props;

  return (
    <Box sx={boxStyles}>
      <div className={classes.inpBlock}>
        <Box sx={inputRowStyles}>
          <FormControl fullWidth>
            <TextField
              id="first name"
              value={volunteer?.firstName}
              label="First name"
              className={classes.modalContactInp}
              sx={borderInput}
            />
          </FormControl>
          <FormControl fullWidth >
            <TextField
              fullWidth
              autoComplete="off"
              id="last name"
              label="Last Name"
              value={volunteer?.lastName}
              className={classes.modalContactInp}
              sx={borderInput}
            />
          </FormControl>
        </Box>
      </div>
      <div className={classes.inpBlock}>
        <Box sx={inputRowStyles}>
          <FormControl fullWidth>
            <TextField
              id="gender"
              label="Gender"
              value={toCapitalizeCase(volunteer?.gender)}
              autoComplete="off"
              className={classes.modalContactInp}
              sx={borderInput}
            />
          </FormControl>
          <FormControl fullWidth >
            <TextField
              fullWidth
              autoComplete="off"
              id="phone number"
              label="Phone Number"
              value={volunteer?.phoneNumber}
              className={classes.modalContactInp}
              sx={borderInput}
            />
          </FormControl>
        </Box>
      </div>
      <div className={classes.inpBlock}>
        <Box sx={inputRowStyles}>
          <FormControl fullWidth>
            <TextField
              id="Email"
              label="Email"
              value={volunteer?.contactEmail}
              className={classes.modalContactInp}
              sx={borderInput}
            />
          </FormControl>
        </Box>
      </div>
    </Box>
  );
};
